export const strictlyNecessaryCookieData = [
  {
    id: "_dd_s",
    company: { name: "Datadog", url: "https://www.datadoghq.com" },
    party: "3rd Party",
    use: "Error handling",
    lifespan: "15 minutes",
  },
  {
    id: "dd_site_test_*",
    company: { name: "Datadog", url: "https://www.datadoghq.com" },
    party: "3rd Party",
    use: "Temporary cookie used to test for cookie support.",
    lifespan: "1 second",
  },
  {
    id: "dd_cookie_test_*",
    company: { name: "Datadog", url: "https://www.datadoghq.com" },
    party: "3rd Party",
    use: "Temporary cookie used to test for cookie support.",
    lifespan: "1 second",
  },
  {
    id: ".AspNetCore.Identity.Application",
    company: { name: "ZORQK", url: "https://www.ZORQKhomes.co.uk" },
    party: "Internal",
    use: "Stores user authentication details",
    lifespan: "Session",
  },
  {
    id: ".AspNetCore.Antiforgery.*",
    company: { name: "ZORQK", url: "https://www.ZORQKhomes.co.uk" },
    party: "Internal",
    use: "Anti-forgery token for security of authentication",
    lifespan: "Session",
  },
  {
    id: "ARRAffinitySameSite",
    company: { name: "Azure", url: "https://azure.microsoft.com" },
    party: "3rd Party",
    use: "Used to affinitize a client to an Azure Web App instance",
    lifespan: "Session",
  },
  // …add more rows as needed
];

export const functionalCookiesTableData = [
  {
    id: "ajs_user_id",
    company: { name: "Segment", url: "https://segment.com" },
    party: "3rd Party",
    use: "Used by Segment to link anonymous ID with ZORQK userID",
    lifespan: "localStorage",
  },
  {
    id: "ajs_anonymous_id",
    company: { name: "Segment", url: "https://segment.com" },
    party: "3rd Party",
    use: "used by Segment to anonymously correlate user sessions",
    lifespan: "localStorage",
  },
  {
    id: "ajs_group_id",
    company: { name: "Segment", url: "https://segment.com" },
    party: "3rd Party",
    use: "Segment group id",
    lifespan: "localStorage",
  },
  {
    id: "ajs_user_traits",
    company: { name: "Segment", url: "https://segment.com" },
    party: "3rd Party",
    use: "Store Customer details (traits) for Segment",
    lifespan: "localStorage",
  },
  {
    id: "ajs%3Acookies",
    company: { name: "Segment", url: "https://segment.com" },
    party: "3rd Party",
    use: "Used by Segment to test cookies",
    lifespan: "1 second",
  },
  {
    id: "__tld__",
    company: { name: "Segment", url: "https://segment.com" },
    party: "3rd Party",
    use: "Used to present relevant advertisement based on the visitor's preferences.",
    lifespan: "1 second",
  },
  {
    id: "ZORQK-recently-viewed-cars",
    company: { name: "ZORQK", url: "https://www.ZORQKhomes.co.uk" },
    party: "Internal",
    use: "Stores the ids of the vehicles a user has seen.",
    lifespan: "14 days",
  },
];

export const advertisementCookiesTableData = [
  {
    id: "CONSENT",
    company: {
      name: "Google",
      url: "https://www.google.com",
    },
    party: "3rd Party",
    use: "Google cookie consent tracker",
    lifespan: "2038-01-10",
  },
  {
    id: "IP_JAR",
    company: {
      name: "Google",
      url: "https://www.google.com",
    },
    party: "3rd Party",
    use: "Set via embedded YouTube vids, registers anonymous statistical data.",
    lifespan: "30 days",
  },
  {
    id: "DV",
    company: {
      name: "Google",
      url: "https://www.google.com",
    },
    party: "3rd Party",
    use: "Cookie used to collect website statistics and track conversions and Google Ads",
    lifespan: "0",
  },
  {
    id: "NID",
    company: {
      name: "Google",
      url: "https://www.google.com",
    },
    party: "3rd Party",
    use: "Cookie used to collect website statistics and track conversions and Google Ads",
    lifespan: "6 months",
  },
  {
    id: "IDE",
    company: {
      name: "Google",
      url: "https://www.google.com",
    },
    party: "3rd Party",
    use: "Third party (DoubleClick) cookie used for serving targeted advertisements that are relevant to you across the web",
    lifespan: "390 days",
  },
  {
    id: "_gcl_au",
    company: {
      name: "Google",
      url: "https://www.google.com",
    },
    party: "3rd Party",
    use: "Google AdSense for experimenting with advertisement efficiency",
    lifespan: "90 days",
  },
  {
    id: "_gcl_aw",
    company: {
      name: "Google",
      url: "https://www.google.com",
    },
    party: "3rd Party",
    use: "Used by the conversion linker for click information",
    lifespan: "90 days",
  },
];

export const marketingAnalyticsCookiesTableData = [
  {
    id: "ad-id",
    company: { name: "Amazon", url: "https://www.amazon.co.uk" },
    party: "3rd Party",
    use: "Used by Amazon Advertising to record user actions and target website content based on ad clicks on a different website",
    lifespan: "13 months",
  },
  {
    id: "ad-privacy",
    company: { name: "Amazon", url: "https://www.amazon.co.uk" },
    party: "3rd Party",
    use: "The cookie is used by Amazon Advertising to manage opt-outs",
    lifespan: "5 years",
  },
  {
    id: "AMZNTOKEN",
    company: { name: "Amazon", url: "https://www.amazon.co.uk" },
    party: "3rd Party",
    use: "When using the hashed PII implementation to pass email, a new cookie called AMZNTOKEN is set",
    lifespan: "3 hour TTL (max 7 days)",
  },
  {
    id: "AMCV_E5F2C8A15481C0E20A4C98BC%40AdobeOrg",
    company: { name: "Adobe", url: "https://www.adobe.com" },
    party: "3rd Party",
    use: "Pattern-type cookie name associated with Adobe Marketing Cloud; stores a unique visitor identifier",
    lifespan: "2 years",
  },
  {
    id: "mbox",
    company: { name: "Adobe", url: "https://www.adobe.com" },
    party: "3rd Party",
    use: "Used by Adobe Target to see which content is most engaging and optimize personalization",
    lifespan: "2 years",
  },
];

export const cookieTableData = [
  {
    name: "Essential Cookies",
    purpose:
      "Required for core website functionality, such as security and navigation.",
  },
  {
    name: "Performance Cookies	",
    purpose:
      "Collect anonymous data on how users interact with the site (e.g., page visits).",
  },
  {
    name: "Functionality Cookies",
    purpose: "Remember user preferences and enhance usability.",
  },
  {
    name: "Targeting/Advertising	",
    purpose:
      "Used to deliver relevant ads and track ad performance (only with consent).",
  },
];
